import styled from 'styled-components';
import { spaceFlowContainer } from 'src/utilities/UIStyles/variables/spacing';
import { blackSphera, whiteSphera } from 'src/utilities/UIStyles/variables/Colors';

export const PersonalInformationContainer = styled.section`
  background-color: rgb(245, 245, 245);

  @media (min-width: 600px) and (max-width: 1024px) {
  }

  @media (max-width: 600px) {
  }
`;

export const Banner = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
  padding: 3% 0 3% 15%;
  background-color: ${whiteSphera};
  > figure {
    width: 85px;
    height: 85px;
    margin-right: 5%;
    > img {
      width: 100%;
      height: 100%;
    }
  }
  > h2 {
    color: ${blackSphera};
    font-size: 3vw;
    width: 16%;
  }

  @media (min-width: 600px) and (max-width: 1024px) {
    > figure {
      > img {
      }
    }

    > h2 {
    }
  }

  @media (max-width: 600px) {
    flex-direction: column;
    justify-content: center;
    padding: 25% 0 5% 0;
    > figure {
      margin-right: 0;
      margin-bottom: 5%;

      > img {
      }
    }
    > h2 {
      text-align: center;
      font-size: 6vw;
      width: 70%;
    }
  }
`;

export const FormContainer = styled.div`
  width: 80%;
  margin: 2.5% auto;
  padding: 2.5% 0;

  @media (min-width: 600px) and (max-width: 1024px) {
  }

  @media (max-width: 600px) {
    width: 95%;
    margin: 5% auto;
    padding: 5%;
  }
`;

export const FormData = styled.form`
  @media (min-width: 600px) and (max-width: 1024px) {
  }

  @media (max-width: 600px) {
  }
`;

export const FormDataRisks = styled.div`
  @media (min-width: 600px) and (max-width: 1024px) {
  }

  @media (max-width: 600px) {
  }
`;

export const RiskInformation = styled.div`
  padding: 2% 4%;
  background-color: ${whiteSphera};
  border-radius: 10px;

  @media (min-width: 600px) and (max-width: 1024px) {
  }

  @media (max-width: 600px) {
  }
`;

export const RiskInformationTitle = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 5%;
  padding: 1% 2%;
  border-radius: 5px;

  > h3 {
    color: ${blackSphera};
    font-size: 1.5vw;
  }

  > div {
    display: flex;
    justify-content: space-evenly;
    align-items: center;
    width: 18%;
    padding: 1% 2%;
    border-radius: 10px;
    background-color: ${blackSphera};

    > p {
      color: ${whiteSphera};
      font-size: 1.5vw;
    }

    > span {
      width: 1px;
      height: 25px;
      background-color: ${whiteSphera};
    }
  }

  @media (min-width: 600px) and (max-width: 1024px) {
    > h3 {
    }

    > div {
      > p {
      }

      > span {
      }
    }
  }

  @media (max-width: 600px) {
    > h3 {
      font-size: 4.2vw;
    }

    > div {
      width: 35%;

      > p {
        font-size: 4.5vw;
      }

      > span {
      }
    }
  }
`;

export const RiskInformationForm = styled.div`
  > div {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 2.5%;

    > p {
      color: ${blackSphera};
      font-size: 1.2vw;
      width: 68%;

      > span {
        font-weight: bold;
      }
    }

    > div {
      display: flex;
      justify-content: flex-end;
      margin-right: 2.5%;

      > input {
        font-size: 1.2vw;
        width: 70px;
        height: 40px;
        cursor: pointer;
      }
    }
  }

  @media (min-width: 600px) and (max-width: 1024px) {
    > div {
      > p {
        > span {
        }
      }

      > div {
        > input {
        }
      }
    }
  }

  @media (max-width: 600px) {
    > div {
      > p {
        text-align: justify;
        font-size: 4vw;
        width: 68%;

        > span {
        }
      }

      > div {
        margin-right: 8%;

        > input {
          font-size: 4.2vw;
          width: 40px;
          height: 30px;
        }
      }
    }
  }
`;

export const ApprovalAndAdvice = styled.div`
  margin-top: 5%;
  padding: 2% 4%;
  background-color: ${whiteSphera};
  border-radius: 10px;

  @media (min-width: 600px) and (max-width: 1024px) {
  }

  @media (max-width: 600px) {
  }
`;

export const ApprovalAndAdviceTitle = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 5%;
  padding: 1% 2%;
  border-radius: 5px;

  > h3 {
    color: ${blackSphera};
    font-size: 1.5vw;
  }

  > div {
    display: flex;
    justify-content: space-evenly;
    align-items: center;
    width: 18%;
    padding: 1% 2%;
    border-radius: 10px;
    background-color: ${blackSphera};

    > p {
      color: ${whiteSphera};
      font-size: 1.5vw;
    }

    > span {
      width: 1px;
      height: 25px;
      background-color: ${whiteSphera};
    }
  }

  @media (min-width: 600px) and (max-width: 1024px) {
    > h3 {
    }

    > div {
      > p {
      }

      > span {
      }
    }
  }

  @media (max-width: 600px) {
    > h3 {
      font-size: 4.2vw;
    }

    > div {
      width: 35%;

      > p {
        font-size: 4.5vw;
      }

      > span {
      }
    }
  }
`;

export const ApprovalAndAdviceForm = styled.div`
  > div {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 2.5%;

    > p {
      color: ${blackSphera};
      font-size: 1.2vw;
      width: 68%;

      > span {
        font-weight: bold;
      }
    }

    > div {
      display: flex;
      justify-content: flex-end;
      margin-right: 2.5%;

      > input {
        font-size: 1.2vw;
        width: 70px;
        height: 40px;
        cursor: pointer;
      }
    }
  }

  @media (min-width: 600px) and (max-width: 1024px) {
    > div {
      > p {
        > span {
        }
      }

      > div {
        > input {
        }
      }
    }
  }

  @media (max-width: 600px) {
    > div {
      > p {
        text-align: justify;
        font-size: 4vw;
        width: 68%;

        > span {
        }
      }

      > div {
        margin-right: 8%;

        > input {
          font-size: 4.2vw;
          width: 40px;
          height: 30px;
        }
      }
    }
  }
`;

export const AboutInvestment = styled.div`
  margin-top: 5%;
  padding: 2% 4%;
  background-color: ${whiteSphera};
  border-radius: 10px;

  @media (min-width: 600px) and (max-width: 1024px) {
  }

  @media (max-width: 600px) {
  }
`;

export const AboutInvestmentTitle = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 5%;
  padding: 1% 2%;
  border-radius: 5px;

  > h3 {
    color: ${blackSphera};
    font-size: 1.8vw;
  }

  > div {
    display: flex;
    justify-content: space-evenly;
    align-items: center;
    width: 18%;
    padding: 1% 2%;
    border-radius: 10px;
    background-color: ${blackSphera};

    > p {
      color: ${whiteSphera};
      font-size: 1.5vw;
    }

    > span {
      width: 1px;
      height: 25px;
      background-color: ${whiteSphera};
    }
  }

  @media (min-width: 600px) and (max-width: 1024px) {
    > h3 {
    }

    > div {
      > p {
      }

      > span {
      }
    }
  }

  @media (max-width: 600px) {
    > h3 {
      font-size: 4.2vw;
    }

    > div {
      width: 35%;

      > p {
        font-size: 4.5vw;
      }

      > span {
      }
    }
  }
`;

export const AboutInvestmentForm = styled.div`
  > div {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 2.5%;

    > p {
      color: ${blackSphera};
      font-size: 1.2vw;
      width: 68%;

      > span {
        font-weight: bold;
      }
    }

    > div:nth-child(1) {
      display: flex;
      flex-direction: column;

      > p {
        color: ${blackSphera};
        font-size: 1.2vw;
        width: 65%;

        > span {
          font-weight: bold;
        }
      }

      > p:nth-child(1) {
        margin-bottom: 2.5%;
      }

      > div:nth-child(2) {
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-bottom: 2.5%;

        > p {
          color: ${blackSphera};
          font-size: 1.2vw;
          width: 70%;

          > span {
            font-weight: bold;
          }
        }

        > div {
          display: flex;
          justify-content: flex-end;
          margin-right: 2.5%;

          > input {
            font-size: 1.2vw;
            width: 70px;
            height: 40px;
            cursor: pointer;
          }
        }
      }
    }

    > div:nth-child(2) {
      display: flex;
      justify-content: flex-end;
      margin-right: 2.5%;

      > input {
        font-size: 1.2vw;
        width: 70px;
        height: 40px;
        cursor: pointer;
      }
    }
  }

  @media (min-width: 600px) and (max-width: 1024px) {
    > div {
      > p {
        > span {
        }
      }

      > div:nth-child(1) {
        > p {
          > span {
          }
        }

        > p:nth-child(1) {
        }

        > div:nth-child(2) {
          > p {
            > span {
            }
          }

          > div {
            > input {
            }
          }
        }
      }

      > div:nth-child(2) {
        > input {
        }
      }
    }
  }

  @media (max-width: 600px) {
    > div {
      > p {
        font-size: 4vw;

        > span {
        }
      }

      > div:nth-child(1) {
        > p {
          font-size: 4vw;
          text-align: justify;

          > span {
          }
        }

        > p:nth-child(1) {
        }

        > div:nth-child(2) {
          > p {
            font-size: 4vw;
            text-align: justify;
            width: 70%;

            > span {
            }
          }

          > div {
            display: flex;
            justify-content: flex-end;
            margin-right: 2.5%;

            > input {
              font-size: 4.2vw;
              width: 40px;
              height: 30px;
            }
          }
        }
      }

      > div:nth-child(2) {
        display: flex;
        justify-content: flex-end;
        margin-right: 2.5%;

        > input {
          font-size: 4.2vw;
          width: 40px;
          height: 30px;
        }
      }
    }
  }
`;

export const InvestorInformation = styled.div`
  padding: 2% 4%;
  background-color: ${whiteSphera};
  border-radius: 10px;
  margin-top: 5%;

  @media (min-width: 600px) and (max-width: 1024px) {
  }

  @media (max-width: 600px) {
  }
`;

export const InvestorInformationTitle = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 5%;
  padding: 1% 2%;
  border-radius: 5px;

  > h3 {
    color: ${blackSphera};
    font-size: 1.8vw;
  }

  > div {
    display: flex;
    justify-content: space-evenly;
    align-items: center;
    width: 18%;
    padding: 1% 2%;
    border-radius: 10px;
    background-color: ${blackSphera};

    > p {
      color: ${whiteSphera};
      font-size: 1.5vw;
    }

    > span {
      width: 1px;
      height: 25px;
      background-color: ${whiteSphera};
    }
  }

  @media (min-width: 600px) and (max-width: 1024px) {
    > h3 {
    }

    > div {
      > p {
      }

      > span {
      }
    }
  }

  @media (max-width: 600px) {
    > h3 {
      font-size: 4.2vw;
    }

    > div {
      width: 35%;

      > p {
        font-size: 4.5vw;
      }

      > span {
      }
    }
  }
`;

export const InvestorInformationForm = styled.div`
  > div:nth-child(1) {
    display: flex;
    justify-content: space-between;
    align-items: center;

    > div:nth-child(1),
    > div:nth-child(2) {
      width: 45%;

      > p {
        color: ${blackSphera};
        font-size: 1.2vw;
        margin-bottom: 1%;
      }

      > input {
        font-size: 1.8vw;
        color: ${blackSphera};
        width: 100%;
        border: none;
      }
    }
  }

  > div:nth-child(2) {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-top: 2.5%;

    > p {
      color: ${blackSphera};
      font-size: 1.2vw;
      width: 68%;

      > span {
        font-weight: bold;
      }
    }

    > div {
      display: flex;
      justify-content: flex-end;
      margin-right: 2.5%;

      > input {
        font-size: 1.2vw;
        width: 70px;
        height: 40px;
        cursor: pointer;
      }
    }
  }

  @media (min-width: 600px) and (max-width: 1024px) {
    > div:nth-child(1) {
      > div:nth-child(1),
      > div:nth-child(2) {
        > p {
        }

        > input {
        }
      }
    }

    > div:nth-child(2) {
      > p {
        > span {
        }
      }

      > div {
        > input {
        }
      }
    }
  }

  @media (max-width: 600px) {
    > div:nth-child(1) {
      justify-content: flex-start;
      align-items: flex-start;
      flex-direction: column;

      > div:nth-child(1),
      > div:nth-child(2) {
        width: 100%;

        > p {
          font-size: 4.2vw;
        }

        > input {
          font-size: 4.2vw;
        }
      }
    }

    > div:nth-child(2) {
      > p {
        font-size: 4vw;
        text-align: justify;

        > span {
        }
      }

      > div {
        > input {
          font-size: 4.2vw;
          width: 40px;
          height: 30px;
        }
      }
    }
  }
`;

export const Container = styled.div`
  ${spaceFlowContainer}

  display: flex;
  justify-content: space-around;

  text-align: center;
`;
